var map = {
	"./error.svg": "Ua7H",
	"./info.svg": "nWSt",
	"./success.svg": "8Obw",
	"./warning.svg": "lQpv"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "LLzX";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/toast ^\.\/.*\.svg$
// module id = LLzX
// module chunks = 46